import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    postAdd,
    getParamsList,
    postEdit,
    postDelete,
    getList,
    patchImg,
    putImg,
    postFormData,
    addParams,
} from "../../../helpers/Helper";
import {
    RiCheckboxCircleLine,
    RiAlertLine,
    RiInformationLine,
} from "react-icons/ri";
import { serialize } from "object-to-formdata";

export const getItemList = createAsyncThunk(
    "/getItemList",
    async (payload) => {
        var data = payload;
        var params = {};

        for (const k in data) {
            if (Object.hasOwnProperty.call(data, k)) {
                if (k === "currentSort" || k === "sortOrder") {
                    params.ordering = data.sortOrder + data.currentSort;
                } else {
                    if (data[k] != "" && k != null && k != "no_of_pages") {
                        params[k] = data[k];
                    }
                }
            }
        }
        try {
            const response = await getParamsList("/masters/item/", params);
            if (response) {
                return { response };
            } else {
                throw new Error(response);
            }
        } catch (error) {
            throw error.message;
        }
    }
);
export const getItemByID = createAsyncThunk(
    "/getItemByID",
    async (payload) => {
        try {
            const response = await getList("/masters/item/" + payload + "/");
            return response.data;
        } catch (error) {
            throw error.message;
        }
    }
);

export const getItemByCompany = createAsyncThunk(
    "/getItemByCompany",
    async (payload) => {
        try {
            const response = await getList("/masters/item/?company=" + payload);
            return response.data;
        } catch (error) {
            throw error.message;
        }
    }
);
export const getItemByLocation = createAsyncThunk(
    "/getItemByLocation",
    async (payload) => {
        try {
            const response = await getList("/masters/item/?location=" + payload);
            return response.data;
        } catch (error) {
            throw error.message;
        }
    }
);